var exports = {
  "G": "AnalyticsPreferencesLink.module__row___eEFhZk",
  "n": "AnalyticsPreferencesLink.module__link___eEFhZk",
};

module.exports = exports;
